import { useEffect, useState } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const LIBRARIES_TO_LOAD = [ "places" ];

// Google calls window.gm_authFailure when the key is rejected (e.g. quota or domain restrictions),
// after the script has loaded, so remember it for every map on the page
let authFailed = false;
const authFailureListeners = new Set<() => void>();
(window as any).gm_authFailure = () => {
  authFailed = true;
  authFailureListeners.forEach(listener => listener());
};

const useGoogleMaps = () => {
  const loader = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY as string,
    libraries: LIBRARIES_TO_LOAD as any
  });
  const [ isAuthFailed, setIsAuthFailed ] = useState(authFailed);

  useEffect(() => {
    const listener = () => setIsAuthFailed(true);
    authFailureListeners.add(listener);
    return () => {
      authFailureListeners.delete(listener);
    };
  }, []);

  // True when maps can't be shown, so callers show their own message instead of Google's developer error
  return { ...loader, hasFailed: !!loader.loadError || isAuthFailed };
};

export default useGoogleMaps;
